import { Tooltip } from "antd";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect, useState } from "react";
import { t } from "ttag";

import Button from "metabase/common/components/Button/Button";
import { trackEvent } from "metabase/jerry/Common/jerry-utils";
import { color } from "metabase/lib/colors";
import type { Card, User } from "metabase-types/api";

export interface PlaysmartButtonProps {
  user?: User;
  card?: Card;
}

const PlaysmartButton = ({ user, card }: PlaysmartButtonProps) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const iconSize = 25;
  const iconColor = color("text-medium");

  useEffect(() => {
    if (
      card?.name?.toLowerCase().includes("ab ") &&
      card?.name?.toLowerCase().includes("test")
    ) {
      setTooltipVisible(true);
      setTimeout(() => {
        setTooltipVisible(false);
      }, 5000);
    }
  }, [card]);

  const handleMouseEnter = () => {
    setTooltipVisible(true); // Show tooltip when hovering over the button
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false); // Hide tooltip when mouse leaves
  };

  function ClickPlaysmartButton(event: { preventDefault: () => void }) {
    event.preventDefault();

    const token = encodeURIComponent(btoa(JSON.stringify(user)));
    const newHref = `https://playsmart.ing.getjerry.com?token=${token}&finish=true&tips=true`;
    // const newHref = `http://localhost:8501?token=${token}`;

    if (newHref) {
      window.open(newHref, "_blank");
    }
    trackEvent(
      {
        eventLabel: "Click Playsmart Button",
      },
      {
        user_info: user,
        href: newHref,
      },
    );
  }

  return (
    <Tooltip title={t`Go to ABTest Analysis Platform`} open={tooltipVisible}>
      <Button
        onClick={ClickPlaysmartButton}
        className="playsmart_button"
        icon="abtest"
        onlyIcon
        iconSize={iconSize}
        color={iconColor}
        data-testid="recent-activity-link"
        style={{
          padding: "-4px",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
    </Tooltip>
  );
};

export default PlaysmartButton;
